module.exports = __webpack_public_path__ + "static/media/truck_garbage.cfa89058.png";